import React from 'react'
import clsx from 'clsx'
import moment from 'moment'
import { isNil } from 'ramda'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@material-ui/core'

import LightTooltip from 'app/componentV4/Tooltip/LightTooltip'

import { renderTitle } from './Commons'
import { getLocalizedDate } from 'commons/date'

export const ColumnOfData = (formatMessage) => [
  {
    header: formatMessage({
      id: 'message.title.label',
    }),
    accessor: 'messageTitle',
    style: { width: '30vw' },
    sort: true,
    render: (row) => (
      <div style={{ width: '30vw' }}>
        {renderTitle(row.title, row.status, formatMessage)}
      </div>
    ),
  },
  {
    header: formatMessage({
      id: 'text.date',
    }),
    accessor: 'createdAt',
    style: { width: '20vw' },
    sort: true,
    render: (row) => {
      return (
        <LightTooltip
          placement="bottom-start"
          title={
            <Typography
              className={clsx(
                'text-14 text-primary p-3',
                !isNil(row?.createdBy?.deletedAt) ? 'line-through' : '',
              )}
            >
              {`${row?.createdBy?.firstName} ${row?.createdBy?.lastName}`}
            </Typography>
          }
        >
          <div>
            <Typography className="whitespace-nowrap text-16 text-neutrals-600 font-normal">
              {getLocalizedDate(row.createdAt)}
            </Typography>
            <Typography className="whitespace-nowrap text-12 text-grey-200 font-normal">
              <FormattedMessage
                id="created.by.label"
                values={{
                  fullName: (
                    <span
                      className={
                        !isNil(row?.createdBy?.deletedAt) ? 'line-through' : ''
                      }
                    >
                      {`${row?.createdBy?.firstName} ${row?.createdBy?.lastName}`}
                    </span>
                  ),
                }}
              />
            </Typography>
          </div>
        </LightTooltip>
      )
    },
  },
  {
    header: formatMessage({
      id: 'aiUsageLog.total.usage.credit.label',
    }),
    accessor: 'credits',
    style: { width: '20vw' },
    sort: true,
  },
]
